import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

import { destinationKey, selectedRecipients } from "./alertRecipients";

export { destinationKey, selectedRecipients };

export default function AlertSettings({ alerts, destinations, onChange, thresholds = [] }) {
  const enabled = Boolean(alerts?.enabled);
  const selected = new Set(alerts?.recipientKeys || []);
  const alertRows = thresholds.filter((row) => row.alert_enabled && String(row.threshold_value ?? "").trim() !== "");
  const toggle = (key, checked) => {
    const next = new Set(selected);
    if (checked) next.add(key);
    else next.delete(key);
    onChange({ ...alerts, recipientKeys: [...next] });
  };
  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      <FormControlLabel
        control={<Switch checked={enabled} onChange={(event) => onChange({ ...alerts, enabled: event.target.checked })} />}
        label={<Typography fontWeight={700}>Turn alerts on for this device</Typography>}
      />
      <Typography variant="body2" fontWeight={600}>
        {enabled ? "Alerts on" : "Alerts off - thresholds are saved but no notifications will be sent"}
      </Typography>
      {enabled && (
        <>
          <Typography variant="caption" sx={{ opacity: 0.8 }}>
            {alertRows.length
              ? `Will alert on: ${alertRows.map((row) => `${row.parameter_label} ${row.threshold_value}`).join(", ")}.`
              : "No threshold has Alert enabled yet. Enable Alert on a threshold for notifications to be sent."}
          </Typography>
          <Typography variant="subtitle2" fontWeight={700} mt={1}>
            Notification recipients
          </Typography>
          {destinations.length === 0 ? (
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Add a contact with an email or mobile phone to choose alert recipients.
            </Typography>
          ) : (
            destinations.map((row) => (
              <FormControlLabel
                key={row.key}
                control={<Checkbox checked={selected.has(row.key)} onChange={(event) => toggle(row.key, event.target.checked)} />}
                label={`${row.label} - ${row.kind === "sms" ? "Text" : "Email"} ${row.value}`}
              />
            ))
          )}
        </>
      )}
    </Box>
  );
}
